/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteDraftStatus;

(function (QuoteDraftStatus) {
  QuoteDraftStatus["DRAFT"] = "draft";
  QuoteDraftStatus["APPLIED"] = "applied";
  QuoteDraftStatus["DELETED"] = "deleted";
  QuoteDraftStatus["REFERRAL"] = "referral";
})(QuoteDraftStatus || (QuoteDraftStatus = {}));